export default class ContactBar {
    locationIndex = pegasus.getCookie("locationIndex");
    openLocationSelector = false;
    searchOpen = false;
    searchTerm = "";
    searchResults = false;
    activeIndex = -1;
    isLoading = false;
    emptyResults = false;

    init() {
        if (!this.locationIndex) {
            const cookie = pegasus.getCookie("currency");

            if (!cookie || (cookie === "") | (cookie.length === 0)) {
                this.locationIndex = "USD";
            } else {
                this.locationIndex = cookie;
            }
        }
    }

    openSearch(href) {
        if (window.innerWidth < 768 && href) {
            window.location.href = href;
        } else {
            this.searchOpen = !this.searchOpen;
            window.setTimeout(() => this.$refs.input.focus(), 10);
        }
    }

    toggleLocation(e) {
        this.locationIndex = e.target.dataset.index;
        pegasus.setCookie("currency", this.locationIndex, 60);
        window.location.href = window.location.href;
    }

    doSearch(e) {
        this.emptyResults = false;

        if (this.searchTerm && this.searchTerm.length > 2) {
            const urlSearchParams = new URLSearchParams({
                action: "get_search_results",
                term: this.searchTerm,
            });

            if (!this.isLoading) {
                this.isLoading = true;

                const fetchContent = async () => {
                    await fetch(ajaxurl + "?" + urlSearchParams.toString(), {
                        method: 'GET',
                        mode: "cors",
                        cache: "no-cache",
                        credentials: "same-origin",
                        headers: {
                            "Content-Type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }).then((resp) => {
                            if (!resp.ok) {
                                this.searchResults = false;
                                this.emptyResults = true;
                                throw Error(resp.statusText);
                            }
                            return resp.json();
                        })
                        .then((response) => {
                            this.searchResults = response;

                            if (this.searchResults.length === 0) {
                                this.emptyResults = true;
                            } else {
                                this.activeIndex = 0;
                            }

                            this.isLoading = false;
                        });
                };

                fetchContent();

            }
        } else {
            this.searchResults = false;
        }
    }

    moveSelection(direction) {
        if (!this.searchResults.length) return;
        if (direction === "up") {
            this.activeIndex =
                this.activeIndex > 0
                    ? this.activeIndex - 1
                    : this.searchResults.length - 1;
        } else if (direction === "down") {
            this.activeIndex =
                this.activeIndex < this.searchResults.length - 1
                    ? this.activeIndex + 1
                    : 0;
        }

        const activeId = document.getElementById(`result_${this.activeIndex}`);

        activeId?.scrollIntoView({ behaviour: "smooth", block: "nearest" });
    }

    selectActive() {
        if (
            this.activeIndex >= 0 &&
            this.activeIndex < this.searchResults.length
        ) {
            window.location.href = this.searchResults[this.activeIndex].url;
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("contactBar", () => new ContactBar());
});
